import React from 'react';
import PropTypes from 'prop-types';

import { useUserData } from './UserDataProvider';

import './AccountInfo/AccountInfo.css';
import usePartnerAvatarUrl from '../lib/usePartnerAvatarUrl';

export default function ProfileAvatar(props) {
  const { showAvatarImage = false } = props;
  const { loading = false, avatarUrl } = usePartnerAvatarUrl(showAvatarImage);
  const { userData = {} } = useUserData();
  const { fullName, loggedIn, username } = userData;

  if (!loggedIn) return null;

  // check for fullName from shopperData, userName from idp or default to '' since all BU should get this avatar
  const profileName = fullName || username || '';
  let initials = profileName.match(/\b\w/g) || [];
  initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();

  if (loading) {
    return (<div data-testid='avatar-loading' className='avatar-picture avatar-initials' />);
  }

  if (showAvatarImage && avatarUrl) {
    return (<img data-testid='avatar-picture' className='avatar-picture' src={ avatarUrl } alt='avatar' />);
  }
  return (<div data-testid='avatar-initials' className='avatar-picture avatar-initials'>{initials}</div>);
}

ProfileAvatar.propTypes = {
  showAvatarImage: PropTypes.bool
};
